import(/* webpackMode: "eager", webpackExports: ["SetTranslationData"] */ "/home/liamto-aality/www/apps/front/src/i18n/SetTranslationData.tsx");
